import { useAuth } from '../auth/AuthContext'
import { auth } from '../api/auth'

export function ImpersonationBanner() {
  const { user, refresh } = useAuth()

  if (!user?.impersonating) {
    return null
  }

  async function handleStopImpersonation() {
    await auth.stopImpersonation()
    await refresh()
    window.location.href = '/admin/users'
  }

  return (
    // sticky (no fixed): empuja el layout hacia abajo en vez de tapar el
    // header de la página que lo monta.
    <div className="sticky top-0 z-50 bg-warning px-lg py-sm text-center text-sm font-medium text-surface">
      <span>
        Estás viendo como <strong>{user.username}</strong> (admin:{' '}
        <strong>{user.impersonating.impersonator_username}</strong>)
      </span>
      <button
        type="button"
        onClick={() => void handleStopImpersonation()}
        className="ml-lg btn-ghost px-md py-xs text-xs"
      >
        Volver a admin
      </button>
    </div>
  )
}
